import { ActivityFeed as Shared } from "@/components/activity/ActivityFeed"
import { renderClipEventSummary } from "./ClipActivityEventCard"
import type { ClipEvent } from "@/components/clips/types"
import type { CurrentUser } from "@/types/inertia"

export function ClipActivityFeed({
  events,
  clipId,
  currentUser,
}: {
  events: ClipEvent[]
  clipId: number
  currentUser: CurrentUser
}) {
  return (
    <Shared
      events={events}
      eventsPath={`/clips/${clipId}/events`}
      currentUser={currentUser}
      renderSummary={renderClipEventSummary}
    />
  )
}
